import { TeamsContainer } from "../containers/teams"

export const Teams = () => {
    return (
        <TeamsContainer />
    )
}